package team.platforma.multiplatform_material_extension.tooltips

import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import team.platforma.multiplatform_material_extension.tooltips.model.PopupPosition

@Composable
fun ContentWithTooltip(popupPosition: PopupPosition, content: @Composable () -> Unit = {}) {
    var showTooltip by remember { mutableStateOf(false) }
    var clickOffset by remember { mutableStateOf(Offset(0f, 0f)) }
    var componentPosition by remember { mutableStateOf(Offset(0f, 0f)) }
    var componentSize by remember { mutableStateOf(IntSize.Zero) }
    val iconSize = 64.dp

    Box(
        modifier = Modifier
            .size(iconSize)
            .onGloballyPositioned { coordinates ->
                componentPosition = coordinates.localToRoot(Offset(0f, 0f))
            }
            .onSizeChanged { size -> // Получаем размер Box
                componentSize = size
            }
            .pointerInput(Unit) {
                detectTapGestures(
                    onLongPress = { offset ->
                        clickOffset = offset
                        showTooltip = true

                        // Автоматически скрыть тултип через 2 секунды
                        CoroutineScope(Dispatchers.Main).launch {
                            delay(2000)
                            showTooltip = false
                        }
                    },
                    onTap = {

                    }
                )
            }

    ) {
        content()
        if (showTooltip) {
            println("clickOffset: $clickOffset")
            TooltipPopup(
                text = "Кастомный тултип $componentPosition",
                positionIn = clickOffset,
                positionOut = componentPosition,
                contentSize = componentSize,
                popupPosition = popupPosition
            )
        }
    }
}

